import { useState } from "react";

export default function ResetPasswordModal({ open, onClose, onSubmit, email }) {
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  if (!open) return null;

  const handleSubmit = () => {
    onSubmit({
      email,
      otp,
      newPassword,
      confirmPassword,
    });
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg flex w-[750px] h-[450px] overflow-hidden">

        {/* Left Image Section */}
        <div className="w-1/2 h-full">
          <img
            src="https://img.freepik.com/free-vector/reset-password-concept-illustration_114360-7967.jpg" 
            alt="reset-password"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Right Form Section */}
        <div className="w-1/2 p-8 flex flex-col justify-center">
          
          <h2 className="text-2xl font-bold mb-6">Reset Password</h2>

          <div className="space-y-4">
            {/* OTP */}
            <div>
              <label className="text-sm text-gray-700">OTP</label>
              <input
                className="w-full border px-3 py-2 rounded-lg"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
              />
            </div>

            {/* New Password */}
            <div>
              <label className="text-sm text-gray-700">New Password</label>
              <input
                type="password"
                className="w-full border px-3 py-2 rounded-lg"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
              />
            </div>

            {/* Confirm */}
            <div>
              <label className="text-sm text-gray-700">Confirm Password</label>
              <input
                type="password"
                className="w-full border px-3 py-2 rounded-lg"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm password"
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 mt-6">
            <button
              className="px-4 py-2 bg-gray-200 rounded-lg"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-lg"
              onClick={handleSubmit}
            >
              Reset Password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
